<template>
	<div>
		<router-view />
		<Olark />
	</div>
</template>

<style>
@import url(https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,400;0,700;1,400;1,700&display=swap);
@import url(~@/assets/css/bootstrap-grid.min.css);
@import url(~@/assets/css/bootstrap-reboot.min.css);
@import url(~@/assets/css/style.css);
</style>

<script type="text/javascript">
import Olark from '@/components/Olark.vue';

export default {
	components: {
		Olark,
	},
};
</script>
